import {
	Injectable,
	InjectionToken
} from '@angular/core';

import {
	ExtranauteModel,
	IsConnectModel
} from 'dd1pnds-ngx-services';

export const APP_CONFIG = new InjectionToken('app.config');

export const AppConfig: any = {
	repositoryURL: 'https://git.agora.msanet/pnds/dd1pnds-apps/app-template-pnds'
};

export const ICON_IDS = [
	// Liste des atouts de l'application
	'checklistAvvcIcon',
	'hourglassClockAvvcIcon'
];

@Injectable()
export class VariablesGlobales {
	isLogged: IsConnectModel;
	extranaute: ExtranauteModel;
}

